<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
  viewBox="0 0 105 77"
   xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Pracovní_x0020_plocha">
    <g id="_627962088">
     <path class="fil0" d="M17 25l0 3c-2,0 -5,1 -6,2 -4,3 -8,6 -9,10 -3,8 -2,16 3,22 6,7 13,7 22,7l0 -6c-6,0 -10,1 -15,-3l-2 -2c-3,-4 -4,-5 -4,-11 0,-4 3,-8 6,-10 1,-1 3,-3 5,-3 2,-1 4,-1 7,-1 0,-2 -1,-4 -1,-7 0,-8 5,-15 11,-18 7,-3 15,-3 21,2 2,1 6,6 6,8 2,0 7,-3 13,0 6,2 8,7 8,13 7,0 14,5 16,12 2,6 -1,13 -6,17 -2,2 -4,2 -6,3 -4,1 -9,-1 -9,1 0,6 0,5 4,5 6,0 12,-1 17,-6 2,-2 3,-3 4,-6 7,-12 0,-28 -15,-31 0,-2 -2,-6 -3,-7 0,-1 0,-1 -1,-1l-2 -3c-4,-3 -7,-4 -12,-5 -2,0 -4,1 -5,1 -7,-11 -25,-15 -36,-6 -1,1 -2,1 -3,2l0 0c-4,5 -8,11 -8,18z"/>
     <path class="fil0" d="M36 54c0,-9 7,-16 17,-16 14,0 22,17 11,28 -10,11 -28,3 -28,-12zm-6 0c0,9 4,17 12,21 11,5 25,0 31,-11 7,-15 -5,-32 -20,-32 -6,0 -8,0 -12,3 -6,3 -11,11 -11,19z"/>
     <path class="fil1" d="M50 55c-1,-1 -3,-3 -4,-4 -1,1 -4,3 -4,4l4 5c1,1 2,3 3,4l14 -14 -4 -4 -9 9z"/>
    </g>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'ConnectionOk',
};
</script>

<style scoped>
  .fil0 {fill:#666666}
  .fil1 {fill:#83C354}
</style>
